import { useQuery } from '@tanstack/react-query';
import type { Cliente } from '../../types';
import { listiniAPI } from '../../utils/api';
import { CrmProfile, CrmSection, CrmFacts } from '../crm/CrmRecordLayout';

export default function ClientProfileCard({ client }: { client: Cliente }) {
  const { data: listino } = useQuery({ queryKey: ['listino', client.listino_id], queryFn: () => listiniAPI.getListino(client.listino_id!).then(r => r.data), enabled: !!client.listino_id });
  return <CrmProfile record={client}>
    <CrmSection title="Gestione cliente" description="Assegnazione e condizioni commerciali."><CrmFacts items={[
      ['Agente assegnato', client.agente_nome], ['Listino prezzi', listino?.nome],
      ['Canali', client.canali?.map(c => c.nome).join(', ')],
      ['Fatture in Cloud', client.fic_id ? 'Sincronizzato' : 'Non collegato'],
    ]} /></CrmSection>
  </CrmProfile>;
}
